import { Criteria, Provider, ProviderAuthorization } from './interfaces';

export type FetchAuthorizedProviders = Provider[];

export type PostCriteriaResponse = Criteria;

export type FetchUserCriteriaResponse = Criteria;

export type EditCriteriaResponse = Criteria;

export type FetchUserIntegrationUrlResponse = ProviderAuthorization;

export type FetchPickupMeliResponse = {
    user: string;
    providerUserId: number;
    ordersCreated: number;
};

export type FetchDeliveriesTiendaNubeResponse = {
    user: string;
    providerUserId: number;
    ordersCreated: number;
};

export type FetchCarriersMeTiendaNubeResponse = { id: string; name: string }[];

export type FetchPickupShopifyResponse = {
    user: string;
    providerUserId: number;
    ordersCreated: number;
    provider: string;
    status?: number;
};

export type FetchShopifyAuthResponse = {
    _id: string;
};

export type FetchTiendaNubeAuthResponse = {
    _id: string;
};

export type FetchMeliAuthResponse = {
    _id: string;
};

export type FetchShopifyIntegrationUrlResponse = {
    url: string;
};

// New response types for YPF and Google integrations
export type FetchProvidersResponse = {
    id: string;
    name: string;
    available: boolean;
    icon: string;
}[];

export type FetchAuthorizedProvidersResponse = {
    _id: string;
    name: string;
    available: boolean;
    icon: string;
    authorization: {
        id: string;
        completed: boolean;
    };
}[];

export type YpfAuthResponse = {
    token: string;
};

export type DeleteYpfAuthResponse = {
    token: string;
};

export type DeleteGoogleAuthResponse = {
    _id: string;
};
